module.exports = __webpack_public_path__ + "img/atelier_fantar.b9d87156.jpg";